module.exports = __webpack_public_path__ + "static/media/logo-white.730fffe4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-white.svg
// module id = 1010
// module chunks = 1